import React from 'react';
import styleUtils from 'src/utils/styles';
import Column from '../../10-atoms/layout/Column';
import { usePageContext } from './PageContext';
const PageHeader = ({ style, children, ...rest }) => {
    const { contentMaxWidth } = usePageContext();
    return (React.createElement(Column, { bbw: 1, style: style, xAxis: "center", ...rest },
        React.createElement(Column, { style: contentMaxWidth != null && [
                styleUtils.containerWidth, {
                    maxWidth: contentMaxWidth,
                }
            ] }, children)));
};
export default PageHeader;
